@if (this.gs.isVersion2) {
  <section class="dialog-parent-container p-3" #dialogconatiner>
    <div class="action-popup-container">
      <div mat-dialog-title class="dialog-container__header">
        <h2 class="activity-description-bolder">{{dialogTitle}}</h2>
            <span class="header-close icon-cross"  (click)='closeDialog(false)' style="text-align: right;display: block;  cursor: pointer;  font-size: 20px;
            padding-bottom: 15px;"><span class="path1"></span><span class="path2"></span></span>       
        </div>
        <div class="dialog-container__content popup-content">
          <ng-container #dynamicComponent></ng-container>
        </div>
      </div>
      @if (dialogData.showAction) {
        <div class="actions d-flex justify-content-center">
          <button mat-button class="me-5 activity-description-bold popup-buttons" (click)='closeDialog(true)'>
            {{cancelBtn.label || ('cancel' | translate) | uppercase}}
          </button>
          <button mat-button class="popup-confirm-button activity-description-bold popup-buttons" (click)='action(true)' >
            {{okayBtn.label || ('confirm' | translate) | uppercase}}
          </button>
          <!-- <app-button [buttontype]="okayBtn" (valueChange)='action($event)'></app-button> -->
          <!-- <app-button [buttontype]="cancelBtn" (valueChange)='closeDialog($event)' ></app-button> -->
        </div>
      }
      @if (!dialogData.showAction) {
        <div class="actions my-2 jc-center">
          <button mat-button class="m-5 activity-description-bold popup-buttons popup-confirm-button" (click)='closeDialog(true)'>
            {{okayBtn.label || ('ok' | translate) | uppercase}}
          </button>
          <!-- <app-button [buttontype]="okayBtn" (valueChange)='closeDialog($event)'></app-button> -->
        </div>
      }
    </section>
  }

  @if (!this.gs.isVersion2) {
    <section  class="dialog-parent-container" #dialogconatiner [ngStyle]="{'font-family':ps.restaurantWidgetSettings$.value.WidgetCustomization.HeaderFont}">
      <div class="action-popup-container">
        <span class="header-close icon-cross"  (click)='closeDialog(false)' style="text-align: right;display: block;  cursor: pointer;  font-size: 20px;
        padding-bottom: 15px;"><span class="path1"></span><span class="path2"></span></span>
          <div mat-dialog-title class="dialog-container__header">
            <span class="dialog-container__header-title popup-header" [ngStyle]="{'color':ps.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">{{dialogTitle}}</span>
          </div>
          <div class="dialog-container__content popup-content">
            <ng-container #dynamicComponent></ng-container>
          </div>
        </div>
        @if (dialogData.showAction) {
          <div class="actions">
            <app-button [buttontype]="okayBtn" (valueChange)='action(true)'></app-button>
            <app-button [buttontype]="cancelBtn" (valueChange)='closeDialog(true)' ></app-button>
          </div>
        }
        @if (!dialogData.showAction) {
          <div class="actions">
            <app-button [buttontype]="okayBtn" (valueChange)='closeDialog(true)'></app-button>
          </div>
        }
      </section>
    }